import { render, staticRenderFns } from "./PastServiceCard.vue?vue&type=template&id=7a28e008&scoped=true&"
import script from "./PastServiceCard.vue?vue&type=script&lang=js&"
export * from "./PastServiceCard.vue?vue&type=script&lang=js&"
import style0 from "./PastServiceCard.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./PastServiceCard.vue?vue&type=style&index=1&id=7a28e008&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a28e008",
  null
  
)

export default component.exports